<template>
  <div class="app-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'app-card',
};
</script>

<style lang="scss" scoped>
.app-card {
  background: #fff;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.1);
}
</style>
